<tbody *ngFor="let cartEntry of cartEntry?.entries" class="cx-item-list-items">
  <tr class="wishlist-container">
    <td role="cell" class="cx-table-item-container">
      <!-- Item Image -->
      <a
        [routerLink]="{ cxRoute: 'product', params: cartEntry.product } | cxUrl"
        tabindex="-1"
      >
        
        <img class="imageAvailable" *ngIf="cartEntry.product && cartEntry.product.images && cartEntry.product.images.length" src="{{cartEntry.product.images[3].url}}" alt="image">
        <img class="imageNotAvailable" *ngIf="cartEntry.product && !cartEntry.product.images" src="{{ '../../../../../../../assets/images/tea-hot-icon.svg'}}" alt="image">
      </a>
      <div class="cx-info">
        <div *ngIf="cartEntry.product?.name" class="cx-name">
          <a
            class="cx-link"
            [routerLink]="
              { cxRoute: 'product', params: cartEntry.product } | cxUrl
            "
            >{{ cartEntry.product?.name }}</a
          >
        </div>
        <div *ngIf="cartEntry.product?.code" class="cx-code">
          {{ "cartItems.id" | cxTranslate }} {{ cartEntry.product?.code }}
        </div>
      </div>
    </td>
    <!-- Item Price -->
    <div class="price-container">
      <td role="cell" *ngIf="cartEntry.product?.price" class="cx-price">
        <div *ngIf="cartEntry.product?.price" class="cx-value">
          {{ cartEntry.product?.price?.formattedValue }}
        </div>
      </td>
      <!-- Action -->
      <td role="cell" class="cx-actions">
        <app-add-to-ekcart
          [productCode]="cartEntry.product?.code"
          [showQuantity]="false"
        ></app-add-to-ekcart>
        <button
          (click)="removeEntry(cartEntry.product?.code)"
          class="link cx-action-link cx-remove-btn"
        >
          {{ "common.remove" | cxTranslate }}
        </button>
      </td>
    </div>
  </tr>
</tbody>
